import AbstractSymbolSpineAnimationsConfig from "../../vendor_core/core/src/baseConfigs//AbstractSymbolSpineAnimationsConfig";
import ISymbolSpineAnimConfig from "../../vendor_core/core/src/managers/contracts/configurations/ISymbolSpineAnimConfig";
import ISpineAnimSkinConfig from "../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimSkinConfig";
import ISpineAnimStateConfig from "../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimStateConfig";

class SymbolSpineAnimationsConfig
    extends AbstractSymbolSpineAnimationsConfig
    implements ISymbolSpineAnimConfig
{
    name: string = "symbols";
    hasSkins: boolean = true;
    defaultSkin: string = "default";
    activeSkin: string = "default";
    visible: boolean = true;
    states: ISpineAnimStateConfig[] = [
        {
            name: "idle",
            loop: true
        },
        {
            name: "idle_mystery",
            loop: true
        },
        {
            name: "landing",
            loop: false
        },
        {
            name: "transform",
            loop: false
        },
        {
            name: "win",
            loop: false
        }
    ];
    skins: ISpineAnimSkinConfig[] = [
        {
            name: "default",
            states: ["idle_mystery", "landing", "transform"],
            playDefault: true,
            defaultState: "idle_mystery"
        },
        {
            name: "empty",
            states: ["idle", "win"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "a",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "k",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "q",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "j",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "wr",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "h1",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "h2",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "m3",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "m4",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "m5",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "m6",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "cn_blue",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "cn_red",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        },
        {
            name: "cn_yellow",
            states: ["idle", "idle_mystery", "win", "landing", "transform"],
            playDefault: true,
            defaultState: "idle"
        }
    ];
}

export default new SymbolSpineAnimationsConfig();
